<p-confirmDialog [baseZIndex]="10000" rejectButtonStyleClass="p-button-text"></p-confirmDialog>
<p-card class="d-block mx-6">
  <form #manualCleanupForm="ngForm" id="manualCleanupForm" class="d-flex justify-content-center">
    <div class="p-fluid grid w-90 my-4">
      <div class="p-field col-4">
        <p-floatlabel>
          <p-select
              name="customer"
              #customer="ngModel"
              inputId="customerSelected"
              optionLabel="name"
              optionValue="customerId"
              appendTo="body"
              [filter]="true"
              [options]="customersList"
              [(ngModel)]="manualCleanup.customerId"
              (onChange)="customerSelected()"
              required
          />
          <label htmlFor="dayOfTheWeek" translate> Common.Customer </label>
        </p-floatlabel>
        <small *ngIf="customer.touched && customer.errors?.required" class="text-danger" translate>
          Generic Errors.Required Customer
        </small>
      </div>

      <div class="p-field col-3">
        <p-floatlabel>
          <p-multiSelect
            #countries="ngModel"
            appendTo="body"
            id="country"
            name="countries"
            optionLabel="keyValue"
            optionValue="keyValue"
            [(ngModel)]="manualCleanup.countries"
            [options]="countriesList"
            [filter]="true"
            [emptyFilterMessage]="'Common.No Results Found' | translate"
            [disabled]="!manualCleanup.customerId"
            (onChange)="countrySelected($event)"
          > </p-multiSelect>
          <label htmlFor="country" translate> Common.Country </label>
        </p-floatlabel>
        <small *ngIf="countries.touched && countries.errors?.required" class="text-danger" translate>
          Generic Errors.Required Countries
        </small>
      </div>

      <div class="p-field col">
        <p-floatlabel>
          <p-select
              name="periodFrom"
              #periodFrom="ngModel"
              appendTo="body"
              optionLabel="keyTranslated"
              optionValue="keyValue"
              [filter]="true"
              [loading]="isLoadingPeriods"
              [(ngModel)]="manualCleanup.periodFrom"
              [options]="periods"
              [disabled]="!manualCleanup.countries || manualCleanup.countries?.length == 0 || isLoadingPeriods"
              required
          />
          <label translate> Common.Period From </label>
        </p-floatlabel>
        <small *ngIf="periodFrom.touched && manualCleanup.periodFrom?.toString().length == 3" class="text-danger" translate>
          Generic Errors.Required Period From
        </small>
        <small *ngIf="periodFrom.touched && periodFrom.errors?.required" class="text-danger" translate>
          Generic Errors.Required Period From
        </small>
      </div>

      <div class="p-field col">
        <p-floatlabel>
          <p-select
            name="periodTo"
            #periodTo="ngModel"
            appendTo="body"
            optionLabel="keyTranslated"
            optionValue="keyValue"
            [filter]="true"
            [loading]="isLoadingPeriods"
            [(ngModel)]="manualCleanup.periodTo"
            [options]="periods"
            [disabled]="!manualCleanup.countries || manualCleanup.countries?.length == 0 || isLoadingPeriods"
            required
          />
          <label translate> Common.Period To </label>
        </p-floatlabel>
        <small *ngIf="periodTo.touched && periodTo.errors?.required" class="text-danger" translate>
          Generic Errors.Required Period To
        </small>
        <small *ngIf="manualCleanup.periodFrom > manualCleanup.periodTo" class="text-danger" translate>
          Generic Errors.Greater Period From
        </small>
      </div>
    </div>
  </form>
</p-card>
